import {getUrlParams} from './common-utils';
import {ICheckinCheckoutDate} from '@stencil/hotels-common-reducer/src/types';
import addDays from '@stencil/date-utils/src/addDays';
import {appConfig} from '@stencil/hotels-config';
import {defaultCheckinOffset, defaultCheckoutOffset} from './date-utils/default-ci-co-offset';
import parseUrlDateString from './date-utils/parse-url-date-string';
import roomStringUtils from './room-string-utils';

const {defaultRoomString} = appConfig;
export default function parseReviewPageUrlToConfig(url) {
  // vcid: '',
  let defaultCheckinDate = addDays(new Date(), defaultCheckinOffset);
  let defaultCheckoutDate = addDays(new Date(), defaultCheckoutOffset);

  let checkin: ICheckinCheckoutDate = {date: defaultCheckinDate};
  let checkout: ICheckinCheckoutDate = {date: defaultCheckoutDate};
  let roomString: string = defaultRoomString;
  let paxString: string = defaultRoomString;
  const {data, cc = ''} = getUrlParams(url);
  const decodedData = Buffer.from(data, 'base64') || '';
  const parsedData = JSON.parse(decodedData) || {};
  const {
    hc,
    vert,
    strQry,
    v,
    rtc,
    rpc,
    rtn,
    gseg,
    cot,
    gsv,
    fwdParams,
    newui,
    code,
    hmd,
    pay_mode,
    hOfferCode,
    hotelName,
    hotelArea,
    cityCode,
    gtv,
  } = parsedData;
  const destination = {_id: cityCode, n: hotelArea, t: 'city'};
  const selectedProperty = {propertyId: hc, propertyName: hotelName};
  const strQuery = strQry ? strQry.split('-') : [];
  if (strQry && strQuery.length > 3) {
    let ci = strQuery[2] || '';
    let co = strQuery[3] || '';
    paxString = strQuery.slice(4).join('-') || defaultRoomString;
    // roomString = roomStringUtils.oldRoomStrValidator(paxString);
    roomString = roomStringUtils.oldToNewRoomstring(paxString);
    if (ci && co) {
      checkin.date = parseUrlDateString(ci) || defaultCheckinDate;
      checkout.date = parseUrlDateString(co) || defaultCheckoutDate;
    }
  }

  return {
    input: {
      hc,
      vert,
      strQry,
      v,
      rtc,
      rpc,
      rtn,
      gseg,
      cot,
      gsv,
      fwdParams,
      newui,
      code,
      hmd,
      pay_mode,
      paxString,
      hOfferCode,
      hotelArea,
      cityCode,
      gtv,
    },
    checkin,
    checkout,
    roomString,
    destination,
    country: cc,
    selectedProperty,
  };
}
